import { render, staticRenderFns } from "./business_field_list.vue?vue&type=template&id=112204b6&scoped=true"
import script from "./business_field_list.vue?vue&type=script&lang=js"
export * from "./business_field_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112204b6",
  null
  
)

export default component.exports